import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../../shared/config/storeConfig/StoreSchema'
import { instancesActions } from '../slices/instancesSlice'
import { fetchInstances } from './fetchInstances'

export const fetchInitialInstances = createAsyncThunk<
	void,
	{ licenseId: string, searchParams: URLSearchParams },
	ThunkConfig<void>
>('instances/fetchInitialInstances', async (args, thunkAPI) => {
	const { licenseId, searchParams } = args
	const { dispatch } = thunkAPI

	const ip = searchParams.get('ip')
	const sort = searchParams.get('sort')
	const page = searchParams.get('page')
	const limit = searchParams.get('limit')
	const label = searchParams.get('label')
	const direction = searchParams.get('direction')
	const instanceName = searchParams.get('instanceName')
	const productVersion = searchParams.get('productVersion')

	try {
		if (ip) dispatch(instancesActions.setIp(ip))
		if (sort) dispatch(instancesActions.setSort(sort))
		if (page) dispatch(instancesActions.setPage(page))
		if (limit) dispatch(instancesActions.setLimit(limit))
		if (label) dispatch(instancesActions.setLabel(label))
		if (direction) dispatch(instancesActions.setDirection(direction))
		if (instanceName) dispatch(instancesActions.setInstanceName(instanceName))
		if (productVersion) dispatch(instancesActions.setProductVersion(productVersion))
		dispatch(instancesActions.setQueryFilter())

		await dispatch(fetchInstances(licenseId))
	} catch (e) {
		console.log(e)
	}
})